import Vue from "vue";

const URL = "/db/pel_client";
const API_URL = URL + "/api/";
import moment from "moment";

const state = {
  pel_client: [],
  pel_client_loaded: false
};

const getters = {
  pel_clientInjected(state) {
    return state.pel_client;
  },
  pelClientByPeriode(state, getters, rootState) {
    return state.pel_client.filter(tr => {
      let bool = true;
      if (moment(rootState.periode$).isValid()) {
        bool = moment(tr.waktu_mulai).format("YYYY") == rootState.periode$;
      }
      return bool;
    });
  }
};

const mutations = {
  LOADED(state, payload) {
    state.pel_client_loaded = payload;
  },
  SET_PEL_CLIENT(state, payload) {
    state.pel_client = payload;
  }
};

const actions = {
  GET_OPTIONS({ commit }) {
    commit("LOADING", null, { root: true });
    return Vue.axios.get(URL + "/options").then(res => {
      commit("training/SET_PEL_TIPE", res.data.pel_tipe, { root: true });
      commit("training/SET_PEL_TEMPAT", res.data.pel_tempat, {
        root: true
      });
      commit("laman/SET_LAMAN", res.data.laman, { root: true });
      commit("materi/SET_MATERI", res.data.materi, { root: true });
      commit("client/SET_CLIENT", res.data.client, { root: true });
      commit("trainer/SET_TRAINER", res.data.trainer, { root: true });
      commit("LOADING_DONE", null, { root: true });
    });
  },
  GET_PEL_CLIENT({ commit }) {
    commit("LOADING", null, { root: true });
    commit("LOADED", false);
    return Vue.axios.get(API_URL).then(res => {
      commit("LOADED", true);
      commit("SET_PEL_CLIENT", res.data);
      commit("LOADING_DONE", null, { root: true });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
